import { computed } from 'vue';
import { createContext } from '../../utils/create-context.js';

const DEFAULT_LOCALE = computed(() => ({
  dir: "ltr",
  locale: "en-US"
}));
const [LocaleContextProvider, useLocaleContext] = createContext("LocaleContext");

export { DEFAULT_LOCALE, LocaleContextProvider, useLocaleContext };
